import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { StructuredContentRenderer } from '../../../StructuredContentRenderer';

type Props = {
  pros?: StructuredContentDocument[];
  cons?: StructuredContentDocument[];
};

const listClass = css({
  listStyleType: 'disc',
  marginLeft: '4',
  paddingBlockStart: '0',
  paddingBlockEnd: '0',
});

const listItemClass = css({
  display: 'list-item',
  paddingInlineStart: '0',
  paddingInlineEnd: '0',
  paddingBlockStart: '1',
  paddingBlockEnd: '1',
  fontSize: '[13px]',
});

export const ProsAndCons = ({ pros, cons }: Props) => {
  if (!pros && !cons) return null;
  return (
    <div
      className={css({
        paddingInlineStart: { md: '4', base: '0' },
        paddingInlineEnd: { md: '4', base: '0' },
        paddingBottom: '2',
        maxWidth: '[705px]',
        '& p': { fontSize: '[13px]' },
      })}
    >
      {pros && (
        <div className={css({ marginBottom: '7' })}>
          <span className={css({ textStyle: 'textSmallBold' })}>Pros</span>
          <ul className={listClass}>
            {pros.map((pro, idx) => (
              <li className={listItemClass} key={`pros-${idx}`}>
                <StructuredContentRenderer doc={pro} />
              </li>
            ))}
          </ul>
        </div>
      )}
      {cons && (
        <div className={css({ marginBottom: '7' })}>
          <span className={css({ textStyle: 'textSmallBold' })}>Cons</span>
          <ul className={listClass}>
            {cons.map((con, idx) => (
              <li className={listItemClass} key={`cons-${idx}`}>
                <StructuredContentRenderer doc={con} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
